<!--
    La pagina Home
  -->

<div class="page" id="login-page">
  <div class="login-backg"></div>
  <div class="content">
    <div class="container">
      <div id="iniciar" class="section"></div>
    </div>
  </div>
</div>

<div class="page" id="admins-home-page">
  <div class="action-bar dark-bg with-tabs">
    <div class="title" style="line-height: 10px;">
      <img src="img/custom/treme/logo-studio.png" style="height: 54px;" />
      &nbsp;
      <img src="img/custom/treme/logo-treme-verde.png" style="height: 25px;">
      <b style="color:#ddd;font-weight:100;font-size:25px;">|</b>
      <span style="font-size:32px;font-weight:200;">Studio</span>
    </div>
    <div class="actions-set">
      <a class="action-btn back" icon="home" href="#index"></a>
      <a class="action-btn search" href="#"></a>
      <a class="action-btn cancel" href="#iniciar"></a>
      <a class="action-btn sos" href="#">SOS</a>
    </div>
    <div class="tabs">
      <span class="admins-home-breadcrumbs">
        <b class="account-full-name">Cuenta</b> /
        Bienvenid@
        <b class="profile-full-name">Persona</b> /
        Aquí puedes construir tu solución móvil.
        &nbsp;
        <a href="#" class="aside">Necesitas ayuda ?</a>
      </span>
    </div>
  </div>
  <div class="content">
    <div class="container">
      <div class="section" id="home">
        <div class="list-content">
          <table class="admins-home-modules" style="width:100%;">
            <tr>
              <td>
                <ul class="content-grid with-icons" style="">
                  <li class="nav" href="#cuenta?id=-1">
                    <i class="icon ion-briefcase"></i>
                    <h3 class="link" href="#">Tu cuenta</h3>
                    <p>La información, logo y estado de tu cuenta.
                    </p>
                  </li>
                  <li class="nav" href="#personas?estado=A">
                    <i class="icon ion-ios-people"></i>
                    <h3 class="link">Personas</h3>
                    <p>Agrega usuarios y sus datos personales ...
                    </p>
                  </li>
                  <li class="nav" href="#roles?estado=A">
                    <i class="icon ion-university"></i>
                    <h3 class="link">Roles</h3>
                    <p>Define cargos y responsabilidades ...</p>
                  </li>
                </ul>
              </td>
              <td style="vertical-align: top;">
                <ul class="content-grid with-icons">
                  <li class="nav" href="#formularios?estado=E">
                    <i class="icon ion-clipboard"></i>
                    <h3 class="link">Formularios</h3>
                    <p>Diseña y usa tus propios formularios ...</p>
                  </li>
                  <li class="nav" href="#listas?estado=A">
                    <i class="icon ion-ios-albums"></i>
                    <h3 class="link">Listas</h3>
                    <p>Crea y sube las listas que usarás en tus formularios ...</p>
                  </li>
                  <li class="nav" href="#procesos?estado=E">
                    <i class="icon ion-gear-b"></i>
                    <h3 class="link">Procesos</h3>
                    <p>Procesa y transforma los datos recibidos ...</p>
                  </li>
                </ul>
              </td>
              <td>
                <ul class="content-grid with-icons">
                  <li class="nav" href="#metricas?estado=A">
                    <i class="icon ion-speedometer"></i>
                    <h3 class="link">Métricas</h3>
                    <p>Define tus indicadores y métricas ...</p>
                  </li>
                  <li class="nav" href="#reportes?estado=A">
                    <i class="icon ion-document-text"></i>
                    <h3 class="link">Reportes</h3>
                    <p>Diseña tus reportes y consultas...</p>
                  </li>
                  <li class="nav" href="#dashboards?estado=A">
                    <i class="icon ion-easel"></i>
                    <h3 class="link">Tableros</h3>
                    <p>Diseña tus tableros de control ...</p>
                  </li>
                </ul>
              </td>
              <td>
                <ul class="content-grid with-icons">
                  <li class="nav" href="#conectores?estado=A">
                    <i class="icon ion-network"></i>
                    <h3 class="link">Conectores</h3>
                    <p>Configura conectores con otros sistemas ...</p>
                  </li>
                  <li class="nav" href="#dispositivos?estado=A">
                    <i class="icon ion-ipad"></i>
                    <h3 class="link">Dispositivos</h3>
                    <p>Activa, desactiva y monitorea tus móviles ...</p>
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="section" id="flujos">
        <h2>Flujos de trabajo</h2>
        <ul>
          <li>
            <a href="#flujo?id=asd">Un flujo <em>Activo</em></a>
            <p>Una descripción</p>
          </li>
        </ul>
      </div>
      <div class="section" id="accesos">
        <h2>Accesos</h2>
        <ul>
          <li></li>
        </ul>
      </div>
      <div class="section" id="backups">
        <h2>Backups</h2>
        <ul>
          <li></li>
        </ul>
      </div>
      <div class="section" id="pagos">
        <h2>Pagos</h2>
        <ul>
          <li></li>
        </ul>
      </div>

      <div class="section" id="copiar-desde">
        <h2>Copiar desde otra cuenta.</h2>
        <p class="big">
          Advertencia: USAR CON MUUUCHO CUIDADO !!!
          <br />
          Esto va a copiar TODOS los formularios y TODAS las listas
          desde la cuenta solicitada hacia esta cuenta.
          <br />
          IMPORTANTE: el usuario DEBE ser administrador de la cuenta solicitada.
        </p>
        <form id="copy-from-account">
          <ul>
            <li class="StringCtrl required" property="user">
              <label>Usuario <b>*</b></label>
              <input name="user" type="text" size=20 class="big" />
            </li>
            <li class="StringCtrl required" property="passw">
              <label>Contraseña <b>*</b></label>
              <input name="passw" type="text" size=20 class="big" />
            </li>
            <li id="copy-from-results">
            </li>
          </ul>
          <p class="center">
            <button class="accept big CreateBtn"> Copiar ahora !</button>
            <button class="cancel big BackBtn" href="#home"> Cancelar</button>
          </p>
        </form>
      </div>
      <div id="copyright" class="center">
        <p class="center">
        </p>
        <hr style="margin:10px 50px;">
        <p class="center">
          &copy; 2012-2021 TREMÉ TyS S.A. - Todos los derechos reservados.
          <br />
          <b class='version'></b>
        </p>
      </div>
    </div>
  </div>
</div>

<div id="templates" style="display:none;">

  <div id="appl-login-dialog-template">
    <form class="my-login">
      <div>
        <h3 class="dark-bg" style="padding:60px 0 10px 0;margin-top:-42px;text-align:center;">
          <img src="img/custom/treme/logo-treme-degrade-oficial.png" />
        </h3>
        <p class="center">
          <input name="email" type="text" value="" placeholder="Tu usuario">
        </p>
        <p class="center">
          <input name="password" type="password" value="" placeholder="Tu contraseña">
        </p>
        <p class="status"></p>
        <p class="center" name="remote-options">
          Conectar a
          <select name="host">
            <!-- <option value="production">treme.io</option>
            <option value="ts01">ts01</option>
            <option value="local">local</option> -->
          </select>
        </p>
        <p class="dialog-buttons center">
          <button class="no-clear dialog-btn login" type="button">
            Iniciar ahora !
          </button>
        </p>
        <p class="center">
          No estás registrado ? <a href="#registrate">Regístrate !</a>
        </p>
      </div>
    </form>
  </div>

  <div id="appl-registration-dialog-template">
    <form class="my-registration">
      <div>
        <h3 class="dark-bg" style="padding:60px 0 10px 0;margin-top:-42px;text-align:center;">
          <img src="img/custom/treme/logo-treme-degrade-oficial.png" />
        </h3>
        <p>
          <label>Tu empresa*</label>
          <input name="account" type="text" value="" placeholder="El nombre de tu empresa">
        </p>
        <p>
          <label>Nombre(s)* y Apellidos(s)*</label>
          <input name="names" type="text" value="" placeholder="Tu nombre (o nombres) aquí">
          <input name="surnames" type="text" value="" placeholder="Tu apellido (o apellidos) aquí">
        </p>
        <p>
          <label>Correo* y contraseña*</label>
          <input name="email" type="text" value="" placeholder="Tu email aquí">
          <input name="passw" type="password" value="" placeholder="Tu contraseña aquí">
        </p>
        <p class="status"></p>
        <p class="dialog-buttons center">
          <button class="no-clear dialog-btn registrate" type="button">
            Regístrate ahora !
          </button>
        </p>
        <p class="center smaller">Al registrarte estás aceptando los
          <a href="#" class="small">Términos y Condiciones de uso</a>.
        </p>
        <p class="center">
          Ya estás registrado ? <a href="#iniciar">Inicia tu sesión</a>
        </p>
        <p class="center" name="remote-options">
          Nos conectaremos a
          <select class="small" name="host">
            <option value="production">treme</option>
            <option value="develop">dev</option>
            <option value="local">local</option>
          </select>
        </p>
      </div>
    </form>
  </div>

</div><!-- #templates -->


<!--
	Area de Helpers
	Son pedacitos de HTML usado en diferentes partes de la App
	pero que por comodidad ya los tenemos armados y estilados aquí.
-->
<div id="helpers" class="hidden">

  <div id="helper-page-loading">
    <p class="loading big center" style="padding:1em;"> &nbsp; Estamos cargando ...</p>
  </div>

  <div id="helper-warning">
    <p class="failed center due" style="padding:1em;">
      <br />
      <span class="message">&nbsp; Mmmm ... parece que paso algo malo ...</span>
    </p>
  </div>

  <div id="helper-alert">
    <p class="medium center" style="padding:1em;">
      <br />
      <span class="message">&nbsp; Alerta aqui ...</span>
    </p>
  </div>

</div>


<!--
	Temp area (hidden) needed for some rendering tasks
-->
<div id="temp" class="hidden"></div>